//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import GlobalQuote from '~/components/molecules/Editorial/Global/GlobalQuote.vue';
import TrendInspiration from '~/components/molecules/Editorial/Trend/TrendInspiration.vue';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'GlobalQuotePortrait',
  components: {
    GlobalQuote,
    TrendInspiration
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;

      return {
        background_color: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.background_color : _ref13 : _ref13) || '',
        background_image: formatPrismicImage((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.quote_background_image) != null ? _ref12.url : _ref12 : _ref12 : _ref12) || EMPTY_PIXEL,
        image: {
          small: formatPrismicImage((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.image) != null ? (_ref11 = _ref11.small) != null ? _ref11.url : _ref11 : _ref11 : _ref11 : _ref11, ['w_200']) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? (_ref10 = _ref10.image) != null ? (_ref10 = _ref10.medium) != null ? _ref10.url : _ref10 : _ref10 : _ref10 : _ref10, ['w_375']) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.image) != null ? (_ref9 = _ref9.large) != null ? _ref9.url : _ref9 : _ref9 : _ref9 : _ref9, ['w_390,dpr_2']) || EMPTY_PIXEL,
          alt: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.alt : _ref8 : _ref8) || '',
          cinemagraph: {
            mp4: formatPrismicImage((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.video_mp4) != null ? _ref7.url : _ref7 : _ref7 : _ref7, [], '', 'video') || '',
            webm: formatPrismicImage((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? (_ref6 = _ref6.video_webm) != null ? _ref6.url : _ref6 : _ref6 : _ref6, [], '', 'video') || ''
          }
        },
        quote: {
          iconColor: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.quote_icon_color : _ref5 : _ref5) || '',
          textColor: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.quote_text_color : _ref4 : _ref4) || '',
          paragraph: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.quote_text : _ref3 : _ref3) || '',
          signature: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.quote_signature : _ref2 : _ref2) || ''
        },
        image_position: (_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.image_position : _ref : _ref
      };
    },

    isImageRightPosition() {
      return this.currentPayload.image_position === false;
    }

  }
};